import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			className=""
			toastOptions={{
				classNames: {
					toast: 'border border-border shadow-xl rounded-xl',
					description: 'opacity-60',
					actionButton:
						'rounded-xl text-sm font-medium outline-none disabled:pointer-events-none disabled:opacity-50 transition duration-150 ease-in-out relative flex items-center justify-center whitespace-nowrap bg-gradient-to-b from-dark-start to-dark-end text-primary hover:pb-[1px] hover:bg-[#808080] hover:shadow hover:bg-gradient-to-t hover:from-dark-start hover:to-dark-end active:pt-1 h-[32px] px-[12px] rounded-[8px] w-fit gap-2',
					cancelButton:
						'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
					icon: '',
				},
			}}
			{...props}
		/>
	)
}

export { Toaster }
